// extracted by mini-css-extract-plugin
export var container = "_hu-0";
export var content = "_hu-3";
export var customerTitle = "_hu-4";
export var empty = "_hu-5";
export var gray = "_hu-6";
export var header = "_hu-7";
export var info = "_hu-8";
export var loading = "_hu-2";
export var loadingCard = "_hu-9";
export var oneLine = "_hu-a";
export var personName = "_hu-e";
export var pillContainer = "_hu-b";
export var selected = "_hu-1";
export var text = "_hu-c";
export var twoLines = "_hu-d";
export var unread = "_hu-f";
export var unreadIndicator = "_hu-g";